import { customFetch } from "../../api/fetchAApi"
import { ReleaseType } from "../../software-notification/interfaces/notification-data.interface"

const cloudDownloadUri = '/api/about/downloadPackage'
const installPackageUri = '/api/about/packageInstall'
const updateFirmwareUri = '/api/about/updateFirmware'
const hubConnectionString = '/systemHub'
const projectHubConnection = '/projectHub'
const uploadFileUri = '/api/about/upload'
const rollbackUri = '/api/about/rollback/upload'
const retryInstallationUri = '/api/about/retryInstallation'

export type FetchUpdateFirmwareParams = {
    version: string,
    mode: 'online' | 'offline'
}

export type FetchInstallSnapeParams = {
    filename: string,
    mode: 'online' | 'offline',
    installType: 'download' | 'upload' | 'rollback'
}

const fetchUpdateFirmware = async ({ version, mode }: FetchUpdateFirmwareParams) => {
    const response = await customFetch(updateFirmwareUri + "?versionFirmwareName=" + version + "&mode=" + mode, {
        method: 'POST'
    })

    return response
}

const fetchInstallSnape = async ({ filename, mode, installType }: FetchInstallSnapeParams) => {
    const response = await customFetch(installPackageUri + "?filename=" + filename + "&mode=" + mode + "&installType=" + installType, {
        "method": "GET",
        "mode": "cors",
        "credentials": "include"
    })

    return response
}

export type FetchDownloadAndInstallParams = {
    packageMode: number,
    version: string,
    releaseType: ReleaseType,
    hwVersion: string
}

const fetchDownloadAndInstall = async ({ packageMode, version, releaseType, hwVersion }: FetchDownloadAndInstallParams) => {
    const response = await customFetch(`${cloudDownloadUri}?type=${packageMode}&version=${version}&releaseType=${releaseType}&hwVersion=${hwVersion}`, {
        method: 'GET'
    })

    return response
}

const fetchRollback = async ({ fileName, releaseType }: { fileName: string, releaseType: string }) => {
    const response = await fetch(`${rollbackUri}?filename=${fileName}&releaseType=${releaseType}`, {
        method: "GET",
    })

    return response
}

const fetchUploadFile = async ({ formData }: { formData: FormData }) => {
    const response = await fetch(uploadFileUri, {
        body: formData,
        method: "POST"
    })

    return response
}

const fetchRetryInstallation = async () => {
    const response = await fetch(retryInstallationUri, {
        method: "POST"
    })

    return response
}

export {
    cloudDownloadUri,
    installPackageUri,
    updateFirmwareUri,
    hubConnectionString,
    uploadFileUri,
    rollbackUri,
    fetchInstallSnape,
    fetchUpdateFirmware,
    fetchDownloadAndInstall,
    fetchRollback,
    fetchUploadFile,
    projectHubConnection,
    fetchRetryInstallation
}